import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { clsx } from "clsx";
import { useEffect, useState } from "react";
import { BaseComponent } from "./BaseComponent";
import { Box } from "./Box";
import { ColorsProvider } from "../providers/ColorsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { alpha, mergeSx } from "../system";
export const sliderClasses = {
    root: "MinervaSlider-root",
    input: "MinervaSlider-input",
    track: "MinervaSlider-track",
    disabled: "MinervaSlider-disabled",
};
export const Slider = (props) => {
    const { rangeMin = 0, rangeMax = 100, value = 0, onDrag, step = 1, showLabel, disabled = false, color = "surface", colorSet, invertColors, sx, className, ...rest } = useDefaultProps({ props, component: "Slider" });
    const [thumbValue, setThumbValue] = useState(value);
    const rangeLength = rangeMax - rangeMin;
    const progressRight = (rangeMax - thumbValue) / rangeLength;
    const labelLeft = (thumbValue - rangeMin) / rangeLength;
    useEffect(() => {
        setThumbValue(value);
    }, [value]);
    return (_jsx(ColorsProvider, { color: color, colorSet: colorSet, invertColors: invertColors, children: ({ background, color }) => (_jsxs(Box
        /**Slider component needs a parent to decide its width*/
        , { 
            /**Slider component needs a parent to decide its width*/
            height: 2, width: "100%", className: clsx([
                sliderClasses.root,
                disabled && sliderClasses.disabled,
                className,
            ]), sx: mergeSx({
                position: "relative",
                background: (theme) => theme.palette.disabled.main,
                borderRadius: (theme) => theme.radius.default,
                [`& .${sliderClasses.track}`]: {
                    background: background,
                    borderRadius: (theme) => theme.radius.default,
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: `${progressRight * 100}%`,
                },
                [`& .${sliderClasses.input}`]: {
                    position: "absolute",
                    width: "100%",
                    height: 2,
                    margin: 0,
                    top: 0,
                    left: 0,
                    background: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    pointerEvents: "none",
                    "&::-webkit-slider-thumb": {
                        height: 6,
                        width: 6,
                        WebkitAppearance: "none",
                        boxSizing: "border-box",
                        borderRadius: (theme) => theme.radius.full,
                        border: `1px solid ${background}`,
                        backgroundColor: color,
                        pointerEvents: "auto",
                    },
                    "&::-moz-range-thumb": {
                        height: 6,
                        width: 6,
                        MozAppearance: "none",
                        boxSizing: "border-box",
                        borderRadius: (theme) => theme.radius.full,
                        border: `1px solid ${background}`,
                        backgroundColor: color,
                        pointerEvents: "auto",
                    },
                    "&::after": showLabel
                        ? {
                            position: "absolute",
                            content: `"${thumbValue.toString()}"`,
                            fontFamily: (theme) => theme.typography.textFieldLabel.fontFamily,
                            fontSize: (theme) => theme.typography.textFieldLabel.fontSize,
                            color: background,
                            top: -6,
                            left: `${labelLeft * 100}%`,
                            transform: "translateX(-50%)",
                        }
                        : undefined,
                },
                [`&.${sliderClasses.disabled}`]: {
                    pointerEvents: "none",
                    background: (theme) => alpha(theme.palette.disabled.main, 0.5),
                    [`& .${sliderClasses.input}`]: {
                        "&::-webkit-slider-thumb": {
                            backgroundColor: (theme) => theme.palette.disabled.onMain,
                            borderColor: (theme) => theme.palette.disabled.main,
                        },
                        "&::-moz-range-thumb": {
                            backgroundColor: (theme) => theme.palette.disabled.onMain,
                            borderColor: (theme) => theme.palette.disabled.main,
                        },
                    },
                },
            }, sx), ...rest, children: [_jsx(Box, { height: 2, className: clsx([sliderClasses.track, className]) }), _jsx(BaseComponent, { as: "input", type: "range", disabled: disabled, min: rangeMin, max: rangeMax, value: thumbValue, step: step, onChange: (e) => {
                        const newValue = Number(e.target.value);
                        setThumbValue(newValue);
                        onDrag?.(e, newValue);
                    }, className: clsx([sliderClasses.input, className]) })] })) }));
};
//# sourceMappingURL=Slider.js.map